import { Getters } from '../types'

const getters: Getters = {
  searchQuery: (state) => state.query,
  searchTab: (state) => state.tab,
}

export default getters
